import React from "react";
import { useMsal } from "@azure/msal-react";

// Material Dashboard 2 React layouts
import Training from "layouts/SharpWatchLayouts/training";
import AdvTraining from "layouts/SharpWatchLayouts/advTraining";
import LeakEventResponseForm from "layouts/SharpWatchLayouts/leakEventForm";
import PreStartupForm from "layouts/SharpWatchLayouts/preStartupForm";
import EventResponseFlowChart from "layouts/SharpWatchLayouts/eventResponseFlowChart";
import SignOut from "layouts/authentication/Example Auth/sign-out";
import SignIn from "layouts/authentication/sign-in";
import ProtectedPage from "layouts/SharpWatchLayouts/ProtectedPage";

// @mui icons
import Icon from "@mui/material/Icon";

function RoutesList() {
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const userRoles = account?.idTokenClaims?.roles || [];

  // Start with an empty array
  let routes = [];

  // Shen - access to just pdfs
  // ShenREG - access to regular training
  // ShenADv - access to advanced training
  // Add Advanced Training first if the user has an ADV role
  if (userRoles.some((role) => ["ShenADV", "ShenAdmin"].includes(role))) {
    routes.push({
      type: "collapse",
      name: "Advanced Training",
      key: "advTraining",
      icon: <Icon fontSize="small">psychology</Icon>,
      route: "/advTraining",
      component: (
        <ProtectedPage allowedRoles={["ShenADV", "ShenAdmin"]}>
          <AdvTraining />
        </ProtectedPage>
      ),
    });
  }

  // Add the remaining routes
  if (userRoles.some((role) => ["ShenREG", "ShenAdmin"].includes(role))) {
    routes.push({
      type: "collapse",
      name: "Training",
      key: "training",
      icon: <Icon fontSize="small">school</Icon>,
      route: "/training",
      component: (
        <ProtectedPage allowedRoles={["ShenREG", "ShenAdmin"]}>
          <Training />
        </ProtectedPage>
      ),
    });
  }
  routes.push(
    {
      type: "collapse",
      name: "Leak Event Form",
      key: "leakEventForm",
      icon: <Icon fontSize="small">description</Icon>,
      route: "/leakEventForm",
      component: (
        <ProtectedPage allowedRoles={["Shen", "ShenREG", "ShenADV", "ShenAdmin"]}>
          <LeakEventResponseForm />
        </ProtectedPage>
      ),
    },
    {
      type: "collapse",
      name: "Pre Startup Form",
      key: "preStartupForm",
      icon: <Icon fontSize="small">restart_alt</Icon>,
      route: "/preStartupForm",
      component: (
        <ProtectedPage allowedRoles={["Shen", "ShenREG", "ShenADV", "ShenAdmin"]}>
          <PreStartupForm />
        </ProtectedPage>
      ),
    },
    {
      type: "collapse",
      name: "Event Response FlowChart",
      key: "eventResponseFlowChart",
      icon: <Icon fontSize="small">warning</Icon>,
      route: "/eventResponseFlowChart",
      component: (
        <ProtectedPage allowedRoles={["Shen", "ShenREG", "ShenADV", "ShenAdmin"]}>
          <EventResponseFlowChart />
        </ProtectedPage>
      ),
    },
    {
      route: "/authentication/sign-in",
      component: <SignIn />,
    },
    {
      type: "collapse",
      name: "Sign Out",
      key: "sign-out",
      icon: <Icon fontSize="small">logout</Icon>,
      route: "/authentication/sign-out",
      component: <SignOut />,
    }
  );

  return routes;
}

export default RoutesList;
